var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7523 21.9846H19.2164",
    stroke: "#4676FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 18.2166V25.7525",
    stroke: "#4676FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3533 30.413L25.0675 30.4984L24.9183 30.7567L22.8888 34.2719C22.8357 34.3639 22.7028 34.3639 22.6496 34.2719L20.6201 30.7567L20.471 30.4984L20.1851 30.413C16.4625 29.3019 13.75 25.8514 13.75 21.7692C13.75 16.788 17.788 12.75 22.7692 12.75C27.7504 12.75 31.7885 16.788 31.7885 21.7692C31.7885 25.8514 29.0759 29.3019 25.3533 30.413Z",
    stroke: "#4676FA",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 4,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9121 21.3773H19.0801",
    stroke: "#4676FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 17.4612V25.2934",
    stroke: "#4676FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4673 30.1654L25.1815 30.2508L25.0323 30.5091L22.9231 34.1625C22.8565 34.2779 22.69 34.2779 22.6234 34.1625L20.5142 30.5091L20.365 30.2508L20.0792 30.1654C16.1982 29.007 13.3701 25.4095 13.3701 21.1534C13.3701 15.96 17.5801 11.75 22.7733 11.75C27.9665 11.75 32.1764 15.96 32.1764 21.1534C32.1764 25.4095 29.3484 29.007 25.4673 30.1654Z",
    stroke: "#4676FA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrganization);
export default __webpack_public_path__ + "static/media/default-organization.172853b583758e33ca29217614a06cec.svg";
export { ForwardRef as ReactComponent };